import { render, staticRenderFns } from "./WatchedPage.vue?vue&type=template&id=11a9177a&scoped=true"
import script from "./WatchedPage.vue?vue&type=script&lang=js"
export * from "./WatchedPage.vue?vue&type=script&lang=js"
import style0 from "./WatchedPage.vue?vue&type=style&index=0&id=11a9177a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a9177a",
  null
  
)

export default component.exports